import React from 'react'
import about from './about.module.css'
import About1 from './About1'
import Progress from './Progress'
import Connecting from './Connecting'
import Insurence from './Insurence'
import TeamConnect from './TeamConnect'
import Footer from '../Footer/Footer'
import Nav from "../Nav/Nav"
import useStore from '../../../Store'

const About = () => {
    const direction = useStore((state) => state.direction);
    return (
        <div style={{ direction }}>
            <Nav />
            <div className={about.about_container}>
                <About1 />
                <Progress />
                <Connecting />
                <Insurence />
                <TeamConnect />
            </div>
            <Footer />
        </div>
    )
}

export default About